import {Timer} from 'components/common/Timer'
import {TrustBlock} from 'components/common/TrustBlock/TrustBlock'
import {Total} from './Total'

export const Right = () => {
  return (
    <div className="flex flex-col w-full d:w-[386px] gap-4">
      <div className="hidden d:block">
        <Timer />
      </div>
      <Total />
      <TrustBlock />
    </div>
  )
}
